import { useEffect, useRef } from 'react';

import useMonolithApiQuery from '@/hooks/api/useMonolithApiQuery';

const ValidStatus = ['info', 'success', 'error', 'warning'] as const;
export type Status = (typeof ValidStatus)[number];
type Annotation = {
  markdown: string;
  id: number;
  style?: string;
};

export function isValidStatus(s?: string): s is Status {
  if (typeof s === 'undefined') {
    return false;
  }
  return (<readonly string[]>ValidStatus).includes(s);
}
const useBuildAnnotations = ({ inProgress, slug }: { inProgress: boolean; slug: string }) => {
  const { data, refetch } = useMonolithApiQuery<Annotation[], unknown>(
    ['build', slug, 'annotations'],
    `/build/${slug}/annotations`,
    { refetchInterval: inProgress ? 5000 : false },
  );
  const lastProgress = useRef(inProgress);

  useEffect(() => {
    if (lastProgress.current && !inProgress) {
      refetch();
    }
    lastProgress.current = inProgress;
  }, [inProgress, refetch]);

  return Array.isArray(data) ? data : [];
};

export default useBuildAnnotations;
